import React from 'react';
import { useTranslation } from 'react-i18next';

import { MoreHorizIcon } from '@/shared/assets/icons/more-horiz-icon';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';
import { TableViewMenuContent } from '@/shared/components/ui/data-table/components/table-view-menu/table-view-menu-content';
import { TTableViewMenuProps } from '@/shared/components/ui/data-table/components/table-view-menu/table-view-menu.types';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';
import { PopoverOptions } from '@/shared/components/ui/popover/components/popover-options/popover-options.styled';
import { useFilterScope } from '@/shared/features/filter-preferences/context/filter-scope-context';

export const TableViewMenu: React.FC<TTableViewMenuProps> = ({
  contextMenuItems,
}) => {
  const { t } = useTranslation();
  const { scopeKey } = useFilterScope();

  if (!scopeKey && !contextMenuItems) {
    return null;
  }

  return (
    <PopoverController
      trigger={
        <IconButton variant="primary" tooltip={t('ui:table_view.tooltip')}>
          <MoreHorizIcon />
        </IconButton>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {(handleClose) => (
        <PopoverOptions minWidth="240px">
          {contextMenuItems?.(handleClose)}
          {scopeKey && (
            <TableViewMenuContent scopeKey={scopeKey} onClose={handleClose} />
          )}
        </PopoverOptions>
      )}
    </PopoverController>
  );
};
